import React, { useState, useEffect, useMemo } from "react";
import {
  ApplicationRoles,
} from "../../Apis/Organization-User";
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  Typography,
  TextField,
  Paper,
  CircularProgress,
  Grid,
  Alert,
  MenuItem,
  Switch,
  FormControlLabel,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
} from "@mui/material";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { fetchUserTypes } from "../../Apis/UserTypes";
import Header from "../DataLayouts/Header";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import axios from "axios";
import { MAIN_URL } from "../../Configurations/Urls";
import { fetchGeneralCountriesall } from "../../Apis/OrganizationLocation";
import { fetchOrganizationDepartment } from "../../Apis/Department-api";
import { fetchOrganizationEmployee } from "../../Apis/Employee-api";
import SelectWithImage from "../../Components/Inputs/SelectWithImage";
import {
  cannotDeactivateOrganizationUser,
  extractToggleStatusError,
  getCannotDeactivateMessage,
  isCurrentOrganizationUser,
} from "../../utils/organizationUserToggle";
import { resolveOrganizationUserId } from "../../lib/organizationSession";

function readUserIsActive(user) {
  const value = user?.is_active;
  return value === true || value === 1 || value === "1";
}

const isSharedResourceUserType = (type) => {
  const name = String(type?.user_type_name || "").trim().toLowerCase();
  return name === "shared resource" || name === "shared resources";
};

const employeeOptionLabel = (option) => {
  const name = String(option?.name || "").trim();
  if (name) {
    const designation = option?.designation?.designation_name;
    return designation ? `${name} (${designation})` : name;
  }
  return `${option?.first_name || ""} ${option?.last_name || ""}`.trim() || "Unknown";
};

function UsersEdit({ mode = "edit" }) {
  const isViewMode = mode === "view";
  const [btnLoading, setBtnLoading] = useState(false);
  const [Roles, setRoles] = useState([]);
  const { userData } = useAuthStore();
  const [userTypes, setUserTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState(null);
  const [loading, setLoading] = useState();
  const [formErrors, setFormErrors] = useState({});
  const [otherApplicationRoles, setOtherApplicationRoles] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [statusToggling, setStatusToggling] = useState(false);
  const [statusConfirm, setStatusConfirm] = useState(null);
  const [userCounts, setUserCounts] = useState({
    total: 0,
    total_users_count: 0,
    active_users_count: 0,
  });
  const [userDetails, setUserDetails] = useState({
    full_name: "",
    phone_number: "",
    email: "",
    organization_user_type_id: "",
    phone_code: "",
    organization_user_role_id: "",
    application_user_role_id: "",
    organization_department_id: "",
    organization_designation_id: "",
    reporting_manager_id: "",
  });

  const org = userData?.organization;
  const { id } = useParams();
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loadedUserIsShared, setLoadedUserIsShared] = useState(false);

  useEffect(() => {
    if (!org?.organization_id) {
      return;
    }
    ApplicationRoles(org.organization_id)
      .then((data) => {
        setRoles(data?.userroles);
      })
      .catch((err) => {
        setFormErrors(err.message);
      });
  }, [org?.organization_id]);

  useEffect(() => {
    // Custom org roles already carry organization_user_role_id; nothing to derive.
    if (!Roles?.length || userDetails.organization_user_role_id) {
      return;
    }

    if (!userDetails.application_user_role_id) {
      return;
    }

    const match = Roles.find(
      (role) =>
        String(role.application_user_role_id) ===
        String(userDetails.application_user_role_id)
    );

    if (match) {
      setUserDetails((prev) => ({
        ...prev,
        organization_user_role_id: String(match.organization_user_role_id),
      }));
    }
  }, [
    Roles,
    userDetails.application_user_role_id,
    userDetails.organization_user_role_id,
  ]);

  console.log("system roles", Roles);

  useEffect(() => {
    fetchGeneralCountriesall()
      .then((data) => {
        const formatted = data.countries.map((item) => ({
          name: item.country_name,
          code: item.country_code,
          phone_code: item.country_phone_code,
        }));
        setCountries(formatted);
        setCountryCode(formatted.find((item) => item.code === "IN"));
      })
      .catch((err) => setFormErrors(err.message));
  }, []);

  useEffect(() => {
    if (!org?.organization_id) return;
    fetchUserTypes(org.organization_id)
      .then((data) => {
        const list = Array.isArray(data?.userTypes?.data)
          ? data.userTypes.data
          : Array.isArray(data?.userTypes)
            ? data.userTypes
            : Array.isArray(data?.data)
              ? data.data
              : [];
        setUserTypes(list);
      })
      .catch((err) => {
        setFormErrors(err.message);
      });
  }, [org?.organization_id]);

  useEffect(() => {
    if (!org?.organization_id) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.post(
          `${MAIN_URL}/api/organizations/${org.organization_id}/user/filtered`,
          {
            filters: [],
            page: 1,
            pageSize: 1,
            sort: { field: "application_user_full_name", direction: "asc" },
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (cancelled) return;
        const pag = res.data?.pagination ?? {};
        const total = Number(pag.total ?? 0);
        setUserCounts({
          total,
          total_users_count: Number(pag.total_users_count ?? total),
          active_users_count: Number(pag.active_users_count ?? 0),
        });
      } catch (_) {
        /* backend still validates toggle */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [org?.organization_id]);

  // get user by id
  useEffect(() => {
    let getdataById = async () => {
      const response = await axios.get(
        `${MAIN_URL}/api/organizations/${org.organization_id}/user/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log("reponse sos id is ", response);
      const a = response.data.user;
      const currentAppRole =
        a?.role_assignment?.application_user_role?.application_user_role_id;
      const currentOrgRole = a?.role_assignment?.organization_user_role_id;

      setOtherApplicationRoles(a?.other_application_roles || []);
      const typeName =
        a?.user_types?.user_type_name ||
        a?.UserTypes?.user_type_name ||
        "";
      setLoadedUserIsShared(isSharedResourceUserType({ user_type_name: typeName }));
      setIsActive(readUserIsActive(a));
      setUserDetails({
        email: a?.applicationuser?.[0]?.email,
        phone_number: a?.applicationuser?.[0]?.phone_number,
        full_name: a?.applicationuser?.[0]?.full_name,
        organization_user_type_id: a?.organization_user_type_id,
        phone_code: a?.applicationuser[0]?.country_phone_code,
        organization_user_role_id: currentOrgRole ? String(currentOrgRole) : "",
        application_user_role_id: currentAppRole ? String(currentAppRole) : "",
        organization_department_id: a?.organization_department_id
          ? String(a.organization_department_id)
          : "",
        organization_designation_id: a?.organization_designation_id
          ? String(a.organization_designation_id)
          : "",
        reporting_manager_id: a?.reporting_manager_id
          ? String(a.reporting_manager_id)
          : "",
        application_user_id:
          a?.application_user_id ??
          a?.applicationuser?.[0]?.application_user_id ??
          "",
        organization_user_id: a?.organization_user_id ?? id,
      });
      setLoading(false);
    };
    if (id) {
      setLoading(true);
      getdataById();
    }
  }, [id]);

  console.log("formdata", userDetails);

  const handleDetailChange = (e) => {
    const { name, value } = e.target;

    if (name === "organization_user_role_id") {
      const selectedRole = Roles.find(
        (role) => String(role.organization_user_role_id) === String(value)
      );
      setUserDetails((prev) => ({
        ...prev,
        organization_user_role_id: value,
        // Custom org roles have no application role; must not keep a stale one.
        application_user_role_id:
          selectedRole?.application_user_role_id != null
            ? String(selectedRole.application_user_role_id)
            : "",
      }));
      setFormErrors((prev) => ({ ...prev, organization_user_role_id: "" }));
      return;
    }

    if (name === "organization_department_id") {
      setUserDetails((prev) => ({
        ...prev,
        organization_department_id: value,
        organization_designation_id: "",
      }));
      setFormErrors((prev) => ({
        ...prev,
        organization_department_id: "",
        organization_designation_id: "",
      }));
      return;
    }

    setUserDetails((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    if (countryCode?.phone_code) {
      setUserDetails((prev) => ({
        ...prev,
        phone_code: countryCode.phone_code,
      }));
    }
  }, [countryCode]);

  const isValidEmail = (email) => {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(email.trim());
  };

  const validateForm = () => {
    const errors = {};

    // if (!userDetails.email) errors.email = "User's email is required.";

    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // if (!emailRegex.test(userDetails.email)) {
    //   errors.email = "Please enter a valid email address.";
    // }

    if (userDetails.email && !isValidEmail(userDetails.email)) {
      errors.email = "Enter a valid  email address.";
    }

    if (!userDetails.email) errors.email = "Email is required.";

    if (!userDetails.full_name) errors.full_name = "User's Name is required.";

    if (!userDetails.phone_number) errors.phone_number = "Phone is required.";

    if (isEditingSharedResourceUser && !userDetails.organization_department_id) {
      errors.organization_department_id = "Department is required.";
    }
    if (isEditingSharedResourceUser && !userDetails.organization_designation_id) {
      errors.organization_designation_id = "Designation is required.";
    }
    if (isEditingSharedResourceUser && !userDetails.reporting_manager_id) {
      errors.reporting_manager_id = "Reporting manager is required.";
    }

    setFormErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const toggleUserRow = {
    organization_user_id: id,
    is_active: isActive ? 1 : 0,
    __is_active_for_toggle: isActive,
  };
  const cannotDeactivate = cannotDeactivateOrganizationUser(
    toggleUserRow,
    userCounts
  );
  const isEditingSelf =
    isCurrentOrganizationUser(
      {
        organization_user_id: id,
        application_user_id: userDetails.application_user_id,
      },
      userData
    ) || String(id) === String(resolveOrganizationUserId(userData) || "");
  const statusDisabled =
    isViewMode ||
    statusToggling ||
    isEditingSelf ||
    (isActive && cannotDeactivate);
  const deactivateBlockedReason = isEditingSelf
    ? "You cannot deactivate your own account."
    : cannotDeactivate
      ? getCannotDeactivateMessage(userCounts)
      : "";

  const userTypeOptions = useMemo(() => {
    const types = Array.isArray(userTypes) ? userTypes : [];
    const currentType = types.find(
      (type) =>
        String(type?.organization_user_type_id) ===
        String(userDetails.organization_user_type_id)
    );

    if (isSharedResourceUserType(currentType)) {
      return currentType ? [currentType] : [];
    }

    return types.filter((type) => !isSharedResourceUserType(type));
  }, [userTypes, userDetails.organization_user_type_id]);

  const isEditingSharedResourceUser = useMemo(() => {
    if (loadedUserIsShared) return true;
    const currentType = (Array.isArray(userTypes) ? userTypes : []).find(
      (type) =>
        String(type?.organization_user_type_id) ===
        String(userDetails.organization_user_type_id)
    );
    return isSharedResourceUserType(currentType);
  }, [loadedUserIsShared, userTypes, userDetails.organization_user_type_id]);

  useEffect(() => {
    if (!org?.organization_id) {
      setDepartments([]);
      setEmployees([]);
      return;
    }
    fetchOrganizationDepartment(org.organization_id)
      .then((data) => {
        const list = Array.isArray(data?.Departments)
          ? data.Departments
          : Array.isArray(data?.departments)
            ? data.departments
            : Array.isArray(data?.data)
              ? data.data
              : Array.isArray(data)
                ? data
                : [];
        setDepartments(list);
      })
      .catch(() => setDepartments([]));
    fetchOrganizationEmployee(org.organization_id)
      .then((data) => {
        const filtered = (Array.isArray(data) ? data : []).filter(
          (item) =>
            String(item.employment_status_name || item.employment_status || "")
              .toLowerCase() !== "exited"
        );
        setEmployees(filtered);
      })
      .catch(() => setEmployees([]));
  }, [org?.organization_id]);

  useEffect(() => {
    if (
      !isEditingSharedResourceUser ||
      !userDetails.organization_department_id ||
      !org?.organization_id
    ) {
      setDesignations([]);
      return;
    }
    axios
      .get(`${MAIN_URL}/api/department-designation/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          department_id: userDetails.organization_department_id,
          organization_id: org.organization_id,
        },
      })
      .then((res) => {
        setDesignations(Array.isArray(res.data?.data) ? res.data.data : []);
      })
      .catch(() => setDesignations([]));
  }, [
    isEditingSharedResourceUser,
    userDetails.organization_department_id,
    org?.organization_id,
  ]);

  const handleStatusToggleRequest = (event) => {
    const nextActive = event.target.checked;
    if (isEditingSelf && !nextActive) {
      toast.error("You cannot deactivate your own account.");
      return;
    }
    if (
      !nextActive &&
      cannotDeactivateOrganizationUser(
        { ...toggleUserRow, __is_active_for_toggle: true },
        userCounts
      )
    ) {
      toast.error(getCannotDeactivateMessage(userCounts));
      return;
    }
    setStatusConfirm({ nextActive });
  };

  const confirmStatusChange = async () => {
    if (!statusConfirm) return;
    const nextActive = statusConfirm.nextActive;
    setStatusToggling(true);
    try {
      await axios.put(
        `${MAIN_URL}/api/organizations/${org.organization_id}/user/${id}/toggle`,
        { is_active: nextActive },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setIsActive(nextActive);
      setUserCounts((prev) => ({
        ...prev,
        active_users_count: nextActive
          ? Number(prev.active_users_count ?? 0) + 1
          : Math.max(Number(prev.active_users_count ?? 0) - 1, 0),
      }));
      setStatusConfirm(null);
      toast.success(
        `User status updated to ${nextActive ? "Active" : "Inactive"}`
      );
    } catch (err) {
      toast.error(extractToggleStatusError(err));
    } finally {
      setStatusToggling(false);
    }
  };

  const handleFinalSubmit = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);

    try {
      // Prepare payload with only allowed fields for update
      const payload = {
        full_name: userDetails.full_name,
        email: userDetails.email,
        phone_number: userDetails.phone_number,
        phone_code: userDetails.phone_code,
        organization_user_type_id: userDetails.organization_user_type_id,
        email:userDetails?.email,
        organization_user_role_id: userDetails?.organization_user_role_id
          ? Number(userDetails.organization_user_role_id)
          : null,
        application_user_role_id: userDetails?.application_user_role_id
          ? Number(userDetails.application_user_role_id)
          : null,
        ...(isEditingSharedResourceUser
          ? {
              organization_department_id: Number(userDetails.organization_department_id),
              organization_designation_id: Number(userDetails.organization_designation_id),
              reporting_manager_id: Number(userDetails.reporting_manager_id),
            }
          : {}),
      };

      await axios.put(
        `${MAIN_URL}/api/organizations/${org.organization_id}/user/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success("User Updated!");
      setFormErrors({});
      navigate(-1);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 422) {
        const validationErrors =
          err.response.data.message || err.response.data.errors || {};
        setFormErrors(validationErrors);
        const errorMessages = Object.values(validationErrors).flat().join(" ");
        toast.error(errorMessages || "Validation failed.");
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    
      <Header
        mode={mode}
        updateMessage={"Edit User"}
        addMessage={"Add User"}
        homeLink={"/users"}
        homeText={"Users"}
        loading={loading}
        btnLoading={btnLoading}
        onSubmit={handleFinalSubmit}
      >

      <Paper elevation={3} sx={{ p: { xs: 2, md: 3 } }}>
        {otherApplicationRoles.length > 0 && (
          <Alert severity="info" sx={{ mb: 2 }}>
            This user has role(s) in other applications:{" "}
            {otherApplicationRoles.map((role) => role.user_role_name).join(", ")}.
            Select a role below to assign access for this application.
          </Alert>
        )}
        <Grid container spacing={2}>
          <TextField
            value={userDetails.full_name}
            error={!!formErrors.full_name}
            helperText={formErrors.full_name}
            fullWidth
            label="Full Name"
            name="full_name"
            onChange={handleDetailChange}
            disabled={isViewMode}
            required
          />

          <TextField
            value={userDetails.email}
            error={!!formErrors.email}
            helperText={formErrors.email}
            fullWidth
            label="Email"
            name="email"
            type="text"
            onChange={handleDetailChange}
            disabled={isViewMode}
            required
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: "16px",
              width: "100%",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "25%" },
              }}
            >
              <div
                style={{
                  border: "2px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "6px",
                  // padding: "1px 8px",
                }}
              >
                <SelectWithImage
                  value={countryCode}
                  error={false}
                  options={countries}
                  optionkey={"phone_code"}
                  onChange={(e, val) => setCountryCode(val)}
                  width="100%"
                  minWidth="20px"
                  disabled={isViewMode}
                  searchKeys={["name", "phone_code"]}
                />
              </div>
            </Box>

            <TextField
              fullWidth
              label="Phone Number"
              name="phone_number"
              value={userDetails.phone_number}
              error={!!formErrors.phone_number}
              helperText={formErrors.phone_number}
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/\D/g, ""); // Remove non-digits
                if (onlyDigits?.length <= 20) {
                  handleDetailChange({
                    target: { name: "phone_number", value: onlyDigits },
                  });
                }
              }}
              disabled={isViewMode}
              required
              inputProps={{
                maxLength: 20,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </Box>

          <TextField
            select
            fullWidth
            label="User Role"
            name="organization_user_role_id"
            value={userDetails.organization_user_role_id ?? ""}
            onChange={handleDetailChange}
            error={!!formErrors.organization_user_role_id}
            helperText={formErrors.organization_user_role_id}
            disabled={isViewMode || !Roles?.length}
          >
            {Roles?.map((option) => (
              <MenuItem
                key={option.organization_user_role_id}
                value={String(option.organization_user_role_id)}
              >
                {option.user_role_name || option.role_name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            fullWidth
            label="User Type"
            name="organization_user_type_id"
            value={userDetails.organization_user_type_id}
            onChange={handleDetailChange}
            error={!!formErrors.organization_user_type_id}
            helperText={formErrors.organization_user_type_id}
            disabled={isViewMode || isEditingSharedResourceUser}
            required
          >
            {userTypeOptions?.map((option) => (
              <MenuItem
                key={option?.organization_user_type_id}
                value={option?.organization_user_type_id}
              >
                {option?.user_type_name}
              </MenuItem>
            ))}
          </TextField>

          {isEditingSharedResourceUser && (
            <Autocomplete
              fullWidth
              disabled={isViewMode}
              options={departments || []}
              getOptionLabel={(option) => option?.department_name || ""}
              value={
                departments?.find(
                  (dept) =>
                    String(dept?.organization_department_id) ===
                    String(userDetails.organization_department_id)
                ) || null
              }
              onChange={(event, newValue) => {
                handleDetailChange({
                  target: {
                    name: "organization_department_id",
                    value: newValue?.organization_department_id
                      ? String(newValue.organization_department_id)
                      : "",
                  },
                });
              }}
              isOptionEqualToValue={(option, value) =>
                String(option?.organization_department_id) ===
                String(value?.organization_department_id)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Department"
                  name="organization_department_id"
                  required
                  error={!!formErrors.organization_department_id}
                  helperText={formErrors.organization_department_id}
                  fullWidth
                />
              )}
            />
          )}

          {isEditingSharedResourceUser && (
            <Autocomplete
              fullWidth
              disabled={isViewMode || !userDetails.organization_department_id}
              options={designations || []}
              getOptionLabel={(option) => option?.designation_name || ""}
              value={
                designations?.find(
                  (desig) =>
                    String(desig?.organization_designation_id) ===
                    String(userDetails.organization_designation_id)
                ) || null
              }
              onChange={(event, newValue) => {
                handleDetailChange({
                  target: {
                    name: "organization_designation_id",
                    value: newValue?.organization_designation_id
                      ? String(newValue.organization_designation_id)
                      : "",
                  },
                });
              }}
              isOptionEqualToValue={(option, value) =>
                String(option?.organization_designation_id) ===
                String(value?.organization_designation_id)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Designation"
                  name="organization_designation_id"
                  required
                  error={!!formErrors.organization_designation_id}
                  helperText={
                    formErrors.organization_designation_id ||
                    (!userDetails.organization_department_id
                      ? "Select a department first"
                      : "")
                  }
                  fullWidth
                />
              )}
            />
          )}

          {isEditingSharedResourceUser && (
            <Autocomplete
              fullWidth
              disabled={isViewMode}
              options={employees || []}
              getOptionLabel={employeeOptionLabel}
              value={
                employees?.find(
                  (emp) =>
                    Number(emp?.organization_person_id) ===
                    Number(userDetails?.reporting_manager_id)
                ) || null
              }
              onChange={(event, newValue) => {
                handleDetailChange({
                  target: {
                    name: "reporting_manager_id",
                    value: newValue?.organization_person_id
                      ? String(newValue.organization_person_id)
                      : "",
                  },
                });
              }}
              isOptionEqualToValue={(option, value) =>
                Number(option?.organization_person_id) ===
                Number(value?.organization_person_id)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Reporting Manager"
                  name="reporting_manager_id"
                  required
                  error={!!formErrors?.reporting_manager_id}
                  helperText={formErrors?.reporting_manager_id}
                  fullWidth
                />
              )}
            />
          )}

          <Grid item xs={12} sx={{ width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
                mt: 1,
                pt: 2,
                px: 1.5,
                py: 1.5,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                backgroundColor: isActive ? "rgba(8, 145, 178, 0.06)" : "rgba(0,0,0,0.04)",
              }}
            >
              <Box>
                <Typography variant="subtitle2" fontWeight={600}>
                  User Status
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {isEditingSelf
                    ? "You cannot deactivate your own account."
                    : isActive
                      ? "This user can sign in to this organization."
                      : "This user cannot sign in to this organization."}
                </Typography>
              </Box>
              <Tooltip
                title={
                  statusDisabled && (isEditingSelf || cannotDeactivate)
                    ? deactivateBlockedReason
                    : isActive
                      ? "Set user inactive"
                      : "Set user active"
                }
              >
                <span>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isActive}
                        onChange={handleStatusToggleRequest}
                        disabled={statusDisabled}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#0891B2",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "#0891B2",
                            },
                        }}
                      />
                    }
                    label={
                      <Typography fontWeight={600} color={isActive ? "#0891B2" : "text.secondary"}>
                        {isActive ? "Active" : "Inactive"}
                      </Typography>
                    }
                    labelPlacement="start"
                    sx={{ mr: 0 }}
                  />
                </span>
              </Tooltip>
              {statusToggling && <CircularProgress size={20} />}
            </Box>
          </Grid>

          {!isViewMode && (
            <Grid item>
              <Button
                variant="contained"
                onClick={handleFinalSubmit}
                disabled={btnLoading}
                sx={{ display: "none" }}
                aria-hidden
              >
                {btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : (
                  "Update"
                )}
              </Button>
            </Grid>
          )}

          <Grid item sx={{ display: isViewMode ? undefined : "none" }}>
            <Button
              variant="contained"
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 2,
                minWidth: 120,
                textTransform: "capitalize",
                fontWeight: 500,
                mt: 2,
                backgroundColor: "#1976d2",
                "&:hover": { backgroundColor: "#115293" },
              }}
            >
              {isViewMode ? "Back" : "Cancel"}
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Dialog
        open={!!statusConfirm}
        onClose={() => {
          if (!statusToggling) setStatusConfirm(null);
        }}
      >
        <DialogTitle>
          {statusConfirm?.nextActive ? "Activate user?" : "Deactivate user?"}
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to set this user to{" "}
            <strong>{statusConfirm?.nextActive ? "Active" : "Inactive"}</strong>
            {" "}for this organization?
          </Typography>
          {!statusConfirm?.nextActive && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              They will not be able to sign in to this organization until reactivated.
              Other organizations are not affected.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStatusConfirm(null)} disabled={statusToggling}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={confirmStatusChange}
            disabled={statusToggling}
            color={statusConfirm?.nextActive ? "primary" : "warning"}
            sx={
              statusConfirm?.nextActive
                ? {
                    bgcolor: "#0891B2",
                    "&:hover": { bgcolor: "#067a9a" },
                  }
                : undefined
            }
          >
            {statusToggling
              ? "Updating..."
              : statusConfirm?.nextActive
                ? "Yes, activate"
                : "Yes, deactivate"}
          </Button>
        </DialogActions>
      </Dialog>
    </Header>
  );
}

export default UsersEdit;
